module.exports = __webpack_public_path__ + "static/img/innerPageBg.png";